module.exports = __webpack_public_path__ + "img/0.8addfe8.png";